import React from 'react';
import TableRow from '../EquipmentTableRow';
import { Equipment } from '../../../../services/equipmentService';

interface EquipmentTableProps {
    equipment: Equipment[];
    onEdit: (equipment: Equipment) => void;
    onDelete: (equipment: Equipment) => void;
}

const EquipmentTable: React.FC<EquipmentTableProps> = ({ equipment, onEdit, onDelete }) => {
    return (
        <div className="mt-6 bg-white rounded-lg shadow overflow-hidden">
            <table className="min-w-full border-collapse table-auto">
                <thead className="bg-gray-200">
                    <tr>
                        <th className="py-2 px-4 text-left">ID</th>
                        <th className="py-2 px-4 text-left">Equipment Name</th>
                        <th className="py-2 px-4 text-left">Equipment Group</th>
                        <th className="py-2 px-4 text-left">Image</th>
                        <th className="py-2 px-4 text-left">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {equipment.map((item) => (
                        <TableRow
                            key={item.id}
                            equipment={item}
                            onEdit={onEdit}
                            onDelete={onDelete}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default EquipmentTable;
